import axios from 'axios'


function getCookie(name) {
  var matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
  ))
  return matches ? decodeURIComponent(matches[1]) : undefined
}
axios.defaults.headers.post['Content-Type'] = 'application/json'

let headers = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRFToken": getCookie("csrftoken"),
  
  'Accept-Language': document.documentElement.lang,
  
}

export default () => {
  return axios.create({
    headers: headers,
    
  }) 
}





// WEBPACK FOOTER //
// ./src/js/shared/services/Api.js